import { instanceWithAuth } from '@/api/instance';

import type {
  DeleteSubCommentRequestDto,
  PatchSubCommentRequestDto,
  PostSubCommentRequestDto,
} from './subComment.dto';

export function postCommunityPostSubComment(request: PostSubCommentRequestDto) {
  return instanceWithAuth.post('/v3/subComments', request);
}

export function patchCommunityPostSubComment(
  request: PatchSubCommentRequestDto,
) {
  return instanceWithAuth.patch('/v3/subComments', request);
}

export function deleteCommunityPostSubComment(
  request: DeleteSubCommentRequestDto,
) {
  return instanceWithAuth.delete(`/v3/subComments/${request.subCommentId}`);
}
